export var ScheduledAction;

(function (ScheduledAction) {
  ScheduledAction["STEP_FUNCTIONS"] = "step_functions";
})(ScheduledAction || (ScheduledAction = {}));

export var SCHEDULED_ACTIONS = Object.values(ScheduledAction);